export default "__VITE_PUBLIC_ASSET__8374cbfa__"